export default{
    "clinics.detail.cart.modalities.title"    : "Payment Method",
    "clinics.detail.cart.modalities.subtitle" : "Payment Method",
    "clinics.detail.cart.modalities.payNow"   : "Pay Now",
    "clinics.detail.cart.modalities.total"    : "Total",
}